import styled, { css } from 'styled-components';

import { Button } from '@gympass/yoga';
import { Button as MuiButton } from '@mui/material';
import { wellzTheme } from '@wellz-theme/mui';

import * as DivisorStyles from 'components/Divisor/styles';

export const Wrapper = styled.footer`
  ${({ theme }) => css`
    @media screen and (max-width: 1439px) and (min-width: 1024px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: ${theme.yoga.spacing.xsmall}px;

      height: 100%;

      ${DivisorStyles.Divisor} {
        display: none;
      }
    }
  `}
`;

export const HelpCenter = styled(MuiButton)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;

    margin-left: ${theme.yoga.spacing.medium}px;

    font-size: ${theme.yoga.fontSizes.xsmall}px;
    font-weight: ${theme.yoga.fontWeights.normal};

    span {
      color: ${wellzTheme.palette.text.secondary};
    }

    svg {
      width: ${theme.yoga.spacing.medium}px;
      height: ${theme.yoga.spacing.medium}px;
      fill: ${theme.yoga.colors.checkboxBorderColor};

      display: none;
    }

    @media screen and (max-width: 1439px) and (min-width: 1024px) {
      margin-left: 0;
      justify-content: center;

      > svg {
        display: block;
        margin: 0;
      }

      > span {
        display: none;
      }
    }
  `}
`;

export const UserWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;

    margin-top: ${wellzTheme.spacing(2)};
    margin-bottom: ${wellzTheme.spacing(3)};
    margin-left: ${wellzTheme.spacing(2)};
    margin-right: ${wellzTheme.spacing(2)};

    @media screen and (max-width: 1439px) and (min-width: 1024px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: ${theme.yoga.spacing.xsmall}px;

      margin: 0;

      div:first-child {
        // Avatar.Circle component
        width: ${theme.yoga.spacing.xxlarge}px;
        height: ${theme.yoga.spacing.xxlarge}px;
      }
    }
  `}
`;

export const UserInfo = styled.div`
  ${({ theme }) => css`
    margin-left: ${theme.yoga.spacing.xxsmall}px;
    margin-right: auto;

    @media screen and (max-width: 1439px) and (min-width: 1024px) {
      display: none;
    }
  `}
`;

export const Logout = styled(Button.Icon)`
  @media screen and (max-width: 1439px) and (min-width: 1024px) {
    width: ${wellzTheme.spacing(2.5)};
    height: ${wellzTheme.spacing(2.5)};

    svg {
      width: ${wellzTheme.spacing(2.5)};
      height: ${wellzTheme.spacing(2.5)};
    }
  }
`;
